import cn from "classnames";
import styles from "./Spinner.module.scss";

export function Spinner({ className }) {
  return <div className={cn(styles.spinner, className)} />;
}
